import { type FC } from 'react';
import {
  Plugs
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconPlugsProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconPlugs: FC<UiIconPlugsProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Plugs}
      {...props}
    />
  );
};
